import { render, staticRenderFns } from "./IntegrationWidgetContent.vue?vue&type=template&id=b7d6a2a8"
import script from "./IntegrationWidgetContent.vue?vue&type=script&lang=js"
export * from "./IntegrationWidgetContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../CitizenPortalUI_Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports